/*
 *             Copyright (c) 2016 - 2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
'use strict';var __importDefault=this&&this['__importDefault']||function(_0x3fed6c){return _0x3fed6c&&_0x3fed6c['__esModule']?_0x3fed6c:{'default':_0x3fed6c};};Object['defineProperty'](exports,'__esModule',{'value':!0x0}),exports['_SERVICE']=void 0x0;const sessioncollection_1=__importDefault(require('./sessioncollection'));exports['_SERVICE']=0x3,exports['default']=class{static async['getConnectedSessions'](_0x42a353,_0x1bb410,_0x4b4a29){const _0x18c6dc=new sessioncollection_1['default'](_0x1bb410,_0x4b4a29);return await _0x18c6dc['connect'](_0x42a353),_0x18c6dc;}};